import { useMemoizedContentGetter } from 'utils/contentful'
import Section from 'components/Section'
import { memo } from 'react'
import { MediaImageStandard, Typography } from '@/components/Contentful'

const GridSectionModule = memo(function GridSectionModule({ config }) {
  const { title, subTitle, items } = config || {}
  return (
    <Section
      disableGutters={true}
      data-testid="grid-section"
      className="py-12 sm:py-20 px-5 md:px-8"
    >
      <div className="grid grid-cols-4 gap-x-4 gap-y-6 sm:gap-8 breakpointMd:grid-cols-6 breakpointLg:grid-cols-12 breakpointLg:gap-8 max-w-[1216px] mx-auto">
        <div className="col-span-4 breakpointMd:col-span-6 breakpointLg:col-span-12 breakpointXl:col-span-12">
          <Typography
            content={title}
            variant="headingLg"
            className="headingLg font-bold md:text-[52px]! max-w-[800px] m-auto text-left md:text-center pb-2 sm:pb-4 line-clamp-4 md:line-clamp-3 text-pretty"
            data-testid="grid-section-title"
            component="h2"
          />
          <Typography
            content={subTitle}
            variant="bodyMd"
            className="bodyMd md:bodyLg font-light! text-left md:text-center md:pb-4 pb-2 line-clamp-4 md:line-clamp-3 text-pretty"
            data-testid="grid-section-subtitle"
            component="h3"
          />
        </div>
        {items?.map((item, index) => {
          const { title, description, logo } = item || {}
          return (
            <div
              className="col-span-4 breakpointMd:col-span-3 breakpointLg:col-span-4 bg-neutral-25 rounded-xl p-4 sm:p-8"
              key={`grid-section-item-${index}`}
            >
              {logo && (
                <div className="w-[24px] h-[24px] rounded-full flex items-center justify-center mb-4 sm:mb-6">
                  <MediaImageStandard
                    content={{ url: logo }}
                    objectFit="cover"
                    width={24}
                    height={24}
                    priority
                    alt={title}
                  />
                </div>
              )}
              {title && (
                <h3 className="text-base sm:text-xl font-bold text-content-primary my-2 sm:my-4 leading-[120%]! lg:leading-[140%]! line-clamp-3 text-pretty">
                  {title}
                </h3>
              )}
              {description && (
                <p className="text-base sm:text-lg text-content-primary mb-0 mt-2 sm:mt-4 leading-[140%]! line-clamp-6 text-pretty">
                  {description}
                </p>
              )}
            </div>
          )
        })}
      </div>
    </Section>
  )
})

function GridSection({ content }) {
  const { config } = useMemoizedContentGetter(content, ['config'])
  return <GridSectionModule config={config?.jsonContent || {}} />
}

export { GridSection, GridSectionModule }
export default GridSection
